module.exports = __webpack_public_path__ + "assets/media/drift-video-logo-new.1723e591.svg";